import { render } from "./DropdownsPage.vue?vue&type=template&id=2564edf8&ts=true"
import script from "./DropdownsPage.vue?vue&type=script&lang=ts"
export * from "./DropdownsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__